module.exports = "js/webpack/1c021e8bb20ac2f29e3da9ff5815550c.svg";